import { useColorMode } from '@vueuse/core';

/**
 * Global theme mode composable — always dark.
 */
export function useTheme() {
  return useColorMode({
    attribute: 'class',
    storageKey: 'vueuse-color-scheme',
    initialValue: 'dark',
    disableTransition: false,
    // SSR/SSG-safe DOM write. During vite-ssg prerender the env exposes a truthy
    // `window` with no `document`, so VueUse's default handler —
    // window.document.querySelector('html') — throws once per page. The dark
    // class is already baked into index.html (<html class="dark">), so skipping
    // the write during prerender is harmless; on the client it runs as normal.
    onChanged: (mode, defaultHandler) => {
      if (typeof window !== 'undefined' && window.document) defaultHandler(mode);
    },
  });
}
